import React, { FC , useEffect, useState} from 'react';
import MainHeader from '../../../components/Calendar/Header'
import { useDispatch , useSelector} from '../../../store/index'
import { setHeaderView } from '../../../store/application/slice'
import { HEADER_VIEW } from '../../../store/application/types';
import Checkbox from '../../../components/UI/Inputs/Checkbox'
import EditIcon from '../../../components/UI/Icons/Edit'
import QuestionIcon from '../../../components/UI/Icons/Question'
import CustomButton from '../../../components/UI/Buttons/CustomButton'
import { getNotificationSettingsThunk , updateNotificationSettingsThunk} from '../../../store/notifications/thunks';
import { Settings, NotificationSettingPayload } from '../../../store/notifications/types';
import { setNotificationIdAction, updateNotificationDataAction } from '../../../store/notifications/slice';
import { toggleNotificationSettingModalAction } from '../../../store/application/slice';
import { SETTING_TYPE_ALIAS, WEEKS } from '../../../models/notifications';
import { TOAST_MESSAGE } from '../../../components/UI/ToastNotification/ToastNotification'
import { useToasts } from 'react-toast-notifications';
import { isFulfilled, isRejected } from '@reduxjs/toolkit'
import ConfirmPopup from '../../../components/UI/ConfirmPopup'
import { convertToLocalTime } from 'date-fns-timezone'
import { format } from 'date-fns'
import './Notifications.scss'



interface NotificationProps{ }

const Notification:FC<NotificationProps> = ()=>{

    const {settings,projectId} = useSelector((state)=>({
        settings:state.notifications.settings,
        projectId: state.project.currentProject.id
    }))

    const dispatch = useDispatch();
    const { addToast } = useToasts()
    const [isDisableNotificationConfirmaion, setIsDisableNotificationConfirmaion] = useState<boolean>(false)
    const [ disableNotificationData, setDisableNotificationData] = useState<Settings>();

    const getNotificationSettings = async ()=>{
        await dispatch(getNotificationSettingsThunk(projectId));
    } 

    useEffect(()=>{
        dispatch(setHeaderView(HEADER_VIEW.NOTIFICATIONS));
        getNotificationSettings();
    },[projectId])

    const toggleDisableNotificationConfirmationModal = () => {
        setIsDisableNotificationConfirmaion(!isDisableNotificationConfirmaion)
      }

    const checkBoxOnChangeStatus = async(checked:boolean,data:Settings)=>{
        if(checked){
           await dispatch(setNotificationIdAction(data.id))
            dispatch(toggleNotificationSettingModalAction())
        }else{
            setDisableNotificationData(data);
            toggleDisableNotificationConfirmationModal();
        }
    }

    const disableNotification = async()=>{
        if(disableNotificationData){
            const payload: NotificationSettingPayload = {
                notification_id: disableNotificationData.id,
                timeframe_type_id: disableNotificationData.timeframe_type_id,
                status: 0,
                notify_timeframe: disableNotificationData.notify_timeframe,
                type_id:disableNotificationData.type_id
            }
            const response = await dispatch(updateNotificationSettingsThunk(payload))
            if(isFulfilled(response)){
                getNotificationSettings()
                toggleDisableNotificationConfirmationModal();
                addToast(TOAST_MESSAGE.NOTIFICATION_UPDATED, { appearance: 'success' })
                dispatch(updateNotificationDataAction({...disableNotificationData,status:0}))
            } 
        }
    }

    const openEditModal = (data:Settings)=>{
        dispatch(setNotificationIdAction(data.id))
        dispatch(toggleNotificationSettingModalAction())
    }


    const notificationType = (data:Settings)=>{
        switch(data.alias_name){
            case SETTING_TYPE_ALIAS.immediate :
                return 'Immediately'
            break;

            case SETTING_TYPE_ALIAS.hourly:
                return 'Hourly'
            break;

            case SETTING_TYPE_ALIAS.time_frame:
                if(data.notify_timeframe && data.notify_timeframe.hasOwnProperty('scheduledDays')){
                     const { notify_timeframe: { scheduledDays } } = data;
                     return scheduledDays.map((v:number)=>{
                        const timezone:string = Intl.DateTimeFormat().resolvedOptions().timeZone
                        return `${format(convertToLocalTime(new Date(Number(v) * 1000), { timeZone: timezone }),'EE')} - ${format(convertToLocalTime(new Date(Number(v) * 1000), { timeZone: timezone }),'hh:mm a')}`
                     }).join(' , ');
                }
                return '';
            break;
        }
    }

    return (
        <div className='notifications-page-wrapper'>
        <MainHeader/>
            <div className="notification-page__wrapper">
            <div className='notification-page__container'> 
                <div className="notification-page__container__header">Notification Preferences</div>
                    <div className="notification-page__container__content">
                    <table>
                    <thead>
                        <tr>
                        <th className="text-left tb-header">I would like to receive the following notifications:</th>
                        <th colSpan={6} ><div className="time-header"><span className="ml-1">TIMEFRAME</span> <QuestionIcon/></div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {settings.map((v:Settings,k:number)=>(
                             <tr>
                                <td className="text-left" colSpan={3}>{v.name}</td>
                                <td>
                                    <Checkbox  
                                    name={'checkbox_'+v.id}
                                    checked={v.status === 1} 
                                    onClick={({target:{checked}}:React.ChangeEvent<HTMLInputElement>)=>checkBoxOnChangeStatus(checked,v)}/>
                                </td>
                                <td colSpan={2} style={{wordBreak: 'break-all', width:'26%'}}  className="text-left">{v.status ===1?notificationType(v):''}</td>
                                <td colSpan={1} className="text-right">
                                                    
                                {v.status === 1?<CustomButton
                                    className='notification-page__btntransparent'
                                    onClick={() => openEditModal(v)}  
                                    button='subtle'
                                    size='small'
                                >
                                
                                <EditIcon />
                                </CustomButton>:null}
                            
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    </table>

                </div>
            </div>
        </div>
        <ConfirmPopup
        onConfirm={disableNotification}
        onClose={toggleDisableNotificationConfirmationModal}
        isModalOpen={isDisableNotificationConfirmaion}
      >
        Are you sure you want to disable this notification?
      </ConfirmPopup>
        </div>   
    )
}

export default Notification;